<app-top-navbar/>

<div class="wrapper page-signup-confirmation">

  <app-loyalty-club-header [customHTML]="true"/>

  <div class="content">
    <app-alert alertType="info"
               [withIcon]="true">
      {{ 'profiles.signup_confirmation.notice' | translate }}
    </app-alert>

    <button class="btn btn-primary btn-raised btn-block app-btn"
            angulartics2On="click"
            angularticsAction="login_confirmation_page"
            [routerLink]="['../../']"
            [queryParams]="queryParams">
      {{ 'generic.log_in' | translate }} <i class="icon icon-sign-in"></i>
    </button>

  </div>

  <app-loyalty-club-footer/>

</div>
